export const FILTERS_PRIVATE_REQUESTS = 'privateRequests'

export const ORDER = {
  office: 'Онлайн офис',
  job: 'Фриланс и Работа',
  market: 'Проектный маркет'
}

export const TYPE_ORDER = Object.entries(ORDER)

export const SEARCH_QUERY_KEY = 'keyword'
